<template>
  <div
    :class="[
      'flex gap-4',
      { 'flex-col': direction === 'col', 'flex-row': direction === 'row' },
    ]"
  >
    <template v-for="(option, index) in options">
      <label
        :for="getInputId(option.id)"
        :class="['mob-radio', option.extraClases]"
        :key="index"
      >
        <input
          class="hidden"
          type="radio"
          :id="getInputId(option.id)"
          :name="inputName + option.id"
          :disabled="disabled"
          v-model="selectedValue"
          :value="option.id"
        />
        <span class="radio">
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;transform: ;msFilter:;">
            <circle cx="12" cy="12" r="8"></circle>
          </svg>
        </span>
        <span class="flex flex-col gap-1">
          <span :id="'answer-option-' + index">
            {{ getAnswerDescription(option.description, index) }}
          </span>
          <img
            v-if="option.graphUrl"
            :src="option.graphUrl"
            alt=""
            class="max-w-[140px] rounded border border-neutral-200 mt-1"
          />
        </span>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: "MobRadio",
  props: {
    disabled: Boolean,
    options: {
      type: Array,
      required: true,
    },
    inputName: String,
    value: String,
    direction: {
      type: String,
      default: "col",
      validator: (value) => ["row", "col"].includes(value),
    },
  },
  computed: {
    selectedValue: {
      get() {
        return this.value + "";

      },
      set(newValue) {
        this.$emit("input", newValue + "");
        if ('MathJax' in window) {
          this.$nextTick(function() {
            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
          });
        }
      },
    },
  },
  methods: {
    getAnswerDescription: function(answer, index){
      const elements = document.getElementById("answer-option-" + index);
      if(elements){
        elements.innerText = answer;
      } else {
        return answer;
      }
    },
    getInputId(index) {
      return `mob-radio-${this._uid}-option-${index}`;
    },
  },
};
</script>

<style>
.mob-radio {
  @apply inline-flex gap-2 text-left cursor-pointer;
}

.mob-radio input + .radio {
  @apply w-6 h-6 rounded-full border border-neutral-300 text-transparent flex items-center justify-center cursor-pointer transition-colors;
}

.mob-radio input:checked + .radio {
  @apply bg-white border-blue-500 text-blue-600;
}

.mob-radio input:checked:disabled + .radio {
  @apply bg-white border-gray-300 text-gray-300;
}
</style>
